import React from 'react';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { WidgetProps, DEFAULT_BUTTON_TEXT } from '../shared';

import {
  DesktopPhoneNumberWrapper,
  PhoneNumberInput,
  PhoneNumberButton
} from './DesktopPhoneNumberWidget.styles';

export function DesktopPhoneNumberWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  buttonText = DEFAULT_BUTTON_TEXT,
  buttonContent,
  inputProps
}: WidgetProps) {
  return (
    <DesktopPhoneNumberWrapper flexDirection="row">
      <PhoneNumberInput data-e2e="phone-number" {...inputProps} />
      <PhoneNumberButton
        type="submit"
        cfButtonColor={buttonColor as CFColorTokenProp}
        cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
        data-e2e="btn-getting-started"
        data-testid="btn-getting-started"
      >
        {buttonContent || buttonText}
      </PhoneNumberButton>
    </DesktopPhoneNumberWrapper>
  );
}
